<template>
  <section>
    <ChooseTmpl
      ref="chooseTmpl"
      title="选择服务商"
      :resultVal="resultVal"
      :isRadio="isRadio"
      :otherSearchData="otherSearchData"
      :searchBoxDataTmpl="searchBoxDataTmpl"
      :getListApi="getListApi"
      :tableTitle="tableTitle"
      :tableSelectTar="tableSelectTar"
      :showTableTitle="showTableTitle"
      @change="handleResultChange"
      :handleSearchData="handleSearchData"
      :customShow="customShow"
      :showName="showName"
      :clearable="clearable"
      :disabled="disabled"
    >
      <section slot="tableSlot" slot-scope="scope">
        <section>{{scope.row[scope.column.property]}}</section>
      </section>
    </ChooseTmpl>
  </section>
</template>

<script>
import {
  servicerDialogList,
} from 'api/service';
import ChooseTmpl from 'components/choose/tmpl/tmpl.vue';
export default {
  components: {
    ChooseTmpl,
  },
  model: {
    prop: 'resultVal', // 父级传进来的值
    event: 'change',
  },
  props: {
    clearable: { // 清除按钮
      type: Boolean,
      default: false,
    },
    resultVal: {
      default: '',
    },
    isRadio: {
      type: Boolean,
      default: false,
    },
    otherSearchData: {
      type: Object,
      default: () => ({}),
    },
    customShow: { // 是否自定义展示结果
      type: Boolean,
      default: false,
    },
    disabled: { // 禁用状态
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      showName: 'serviceName',
      tableSelectTar: 'serviceUserId',
      searchBoxDataTmpl: {
        form: [
          { // 服务商名称
            label: '服务商名称',
            value: 'serviceName',
            type: 'input',
            placeholder: '请输入服务商名称',
          },
          { // 服务商账号
            label: '服务商账号',
            value: 'serviceUserId',
            type: 'input',
            placeholder: '请输入服务商账号',
          },
        ],
      },
      showTableTitle: [
        {
          prop: 'serviceName',
          label: '服务商名称',
        },
        {
          prop: 'serviceUserId',
          label: '服务商账号',
        },
      ],
      tableTitle: [
        {
          prop: 'serviceUserId',
          label: '服务商账号',
        },
        {
          prop: 'serviceName',
          label: '服务商名称',
        },
        {
          prop: 'mobilePhone',
          label: '服务电话',
        },
        {
          prop: 'companyAddress',
          label: '服务地址',
        },
      ],
    };
  },
  methods: {
    getListApi: servicerDialogList,
    handleResultChange (val) {
      this.$emit('change', val);
    },
    handleSearchData (searchBoxData) {
      return searchBoxData;
    },
    show () {
      this.$refs.chooseTmpl.show();
    },
  },
};
</script>

<style>

</style>
